import React, { useState } from 'react';
import { KeyRound, Mail, SendHorizontal } from 'lucide-react';
import styles from './styles.module.scss';
import InputField from 'components/input-field';
import {useForm} from 'react-hook-form';
import {Button, DialogCloseTrigger, Spinner} from '@chakra-ui/react';
import classNames from 'classnames';
import {sendResetPasswordLink} from 'api/user';

interface FormData {
  email: string;
}

const ForgotForm: React.FC = () => {
  const {
    handleSubmit,
    formState: {errors},
    control
  } = useForm<FormData>({mode: 'onSubmit'});

  const [sending, setSending] = useState(false);

  const onSubmit = async (data: FormData) => {
    setSending(true); // Show spinner
    try {
      // Send reset password link to the provided email
      await sendResetPasswordLink({email: data.email});
    }
    catch (error) {
      // Avoid unhandled promise rejection to prevent app crash (toast error hanled by the api interceptor)
    }
    finally {
      setSending(false); // Hide spinner
    }
  };

  return (
    <form>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <KeyRound />
        </div>
        <p className={styles.title}>Forgot your password?</p>
        <p className={styles.text}>Enter your email address below, and we’ll send you instructions to reset it.</p>

        <InputField
          control={control}
          name={'email'}
          type={'text'}
          placeholder={'example@email.com'}
          label={'Email'}
          startElement={<Mail />}
          rules={{
            required: {value: true, message: 'Field is required'},
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: 'The field must be the email address'
            }
          }}
          error={errors['email']?.message || ''}
        />

        <div className={styles.row}>
          <div className={styles.col}>
            <DialogCloseTrigger>
              <div className={classNames(styles.btn, styles.dark)}>Cancel</div>
            </DialogCloseTrigger>
          </div>
          <div className={styles.col}>
            <Button
              variant="outline"
              className={classNames(styles.btn, styles.green)}
              type="button"
              onClick={handleSubmit(onSubmit)}
              disabled={sending} // Disable button while sending
            >
              {sending ? <Spinner size="sm" /> : <><span>Send</span><SendHorizontal /></>}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default ForgotForm;
